import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { mapArrayToObject } from "../../commonFunctions/arrayFunc";
import ButtonActionIcon from "../../components/BuilderComponents/ButtonActionIcon";
import Button from "../../components/FormComponents/Button";
import Input from "../../components/FormComponents/Input";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import Textarea from "../../components/FormComponents/Textarea";
import AppLeftSideBar from "../../components/SideBar/AppLeftSideBar";
import { useAppOrgContext } from "../../context/AppOrgContext";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { useModalContext } from "../../context/ModalContext";
import Loader from "../../Layouts/Loader/Loader";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import { toastError, toastSuccess } from "../../utils/toastUtils";
import { getToolTipAttributes } from "../../utils/tooltip";
import { UserAssignmentUI } from "./AssignUserToApplication";
import BuilderTabs from "../../Layouts/BuilderTabs";
// import OrgStructure from "./OrgStructure";

const UserGroups = () => {
  const { allApplications } = useAppOrgContext();
  const [allGroupsOrApps, setAllGroupsOrApps] = useState([]);
  const [selectedApplication, setSelectedApplication] = useState(""); // store selected group or app id
  const [selectedUsers, setSelectedUsers] = useState([]);
  const { orgId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAssignOpen, setIsAssignOpen] = useState(false);
  const { getUserConfirmationForDelete } = useModalContext();
  const [searchQuery, setSearchQuery] = useState("");

  const fetchAllAppForUser = async () => {
    try {
      setIsLoading(true);
      setAllGroupsOrApps([]);

      const { data } = await axiosInstance.get(`/user-service/groups/org/${orgId}`);
      if (data && data.length > 0) {
        setAllGroupsOrApps(data);
        setSelectedApplication(data[0].id);
      }
      setIsLoading(false);
    } catch (error) {
      handleApiError(error);
    }
  };
  const assignUser = async (userObj) => {
    const userData = { id: userObj.id, name: userObj.name, email: userObj.email, designation: "Associate" };

    try {
      const newObj = JSON.parse(JSON.stringify(selectedUsers));
      const { message } = await axiosInstance.post(`/user-service/groups/${selectedApplication}/user/${userObj.id}`);
      newObj.push(userData);
      setSelectedUsers(newObj);
      toastSuccess(message);
      updateGroupUserCount(selectedApplication, "add");
      return true;
    } catch (error) {
      handleApiError(error);
      return false;
    }
  };
  const removeUser = async (id) => {
    try {
      const newObj = JSON.parse(JSON.stringify(selectedUsers));
      let msg = "";
      const { message } = await axiosInstance.delete(`/user-service/groups/${selectedApplication}/user/${id}`);
      msg = message;

      const newFields = newObj.filter((user) => user.id !== id);
      setSelectedUsers(newFields);
      toastSuccess(msg);
      updateGroupUserCount(selectedApplication, "remove");
      return true;
    } catch (error) {
      handleApiError(error);
      return false;
    }
  };
  //to update uesr count on group card
  const updateGroupUserCount = (grpId, action) => {
    const groupIndex = allGroupsOrApps.findIndex((group) => group.id === grpId);
    const updatedGroups = JSON.parse(JSON.stringify(allGroupsOrApps));
    if (action === "add") {
      updatedGroups[groupIndex].assign_users_count += 1;
    } else {
      updatedGroups[groupIndex].assign_users_count -= 1;
    }
    setAllGroupsOrApps(updatedGroups);
  };

  const fetchSingleGroupOrApp = async () => {
    try {
      setIsTableLoading(true);
      const { data } = await axiosInstance.get(`/user-service/groups/${selectedApplication}/users`);
      setSelectedUsers(data);
      setIsTableLoading(false);
    } catch (error) {
      handleApiError(error);
    }
  };

  const fetchSearchResults = async (searchTerm) => {
    try {
      const url = searchTerm ? `/user-services/users?search=${searchTerm}&limit=20` : `/user-services/users?limit=10`;
      const { data } = await axiosInstance.get(url);

      return data.filter((user) => !selectedUsers.some((assignedUser) => assignedUser.id === user.id));
    } catch (error) {
      handleApiError(error);
      return [];
    }
  };

  const handleSaveGroup = async (groupData) => {
    if (groupData.name.trim().length < 3) {
      toastError("Atleast 3 characters required");
      return;
    }
    groupData.org_id = orgId;
    try {
      const { data, message } = await axiosInstance.post(`/user-service/groups`, groupData);
      setAllGroupsOrApps((pre) => {
        return [...pre, data];
      });
      setSelectedApplication(data.id);
      setIsModalOpen(false);
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const deleteGroup = async (grpId) => {
    try {
      const userConfirmed = await getUserConfirmationForDelete("");
      if (!userConfirmed) return;

      const { message } = await axiosInstance.delete(`/user-service/groups/${grpId}`);
      const newArray = allGroupsOrApps.filter((pre) => pre.id !== grpId);
      setAllGroupsOrApps(newArray);
      if (newArray.length > 0) {
        setSelectedApplication(newArray[0].id);
      }
      setIsModalOpen(false);
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };
  const editGroup = async (grpId, payload) => {
    try {
      const { message } = await axiosInstance.patch(`/user-service/groups/${grpId}`, payload);
      const newArray = allGroupsOrApps.map((group) => (group.id === grpId ? { ...group, ...payload } : group));
      setAllGroupsOrApps(newArray);

      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    if (selectedApplication !== "") {
      fetchSingleGroupOrApp();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedApplication]);
  useEffect(() => {
    fetchAllAppForUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allApplications]);

  // Filter groups by type and search query
  const adminGroups = allGroupsOrApps.filter(
    (group) => group.type === "admin" && group.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const userGroups = allGroupsOrApps.filter(
    (group) => (group.type === "user" || !group.type) && group.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Render groups function
  const renderGroups = (groups, emptyMessage) => {
    if (groups.length === 0) {
      return (
        <div style={{ fontWeight: "500", fontSize: "24px", margin: "0 auto", marginTop: "50px" }}>{emptyMessage}</div>
      );
    }

    return groups.map((group) => (
      <GroupCard
        key={group.id}
        group={group}
        allApplications={mapArrayToObject(allApplications).result || {}}
        setSelectedApplication={setSelectedApplication}
        deleteGroup={deleteGroup}
        editGroup={editGroup}
        selectedUsers={selectedUsers}
        setIsAssignOpen={setIsAssignOpen}
      />
    ));
  };

  // Render tab content with header
  const renderTabContent = (groups, emptyMessage, showCreateButton = false) => {
    return (
      <>
        <div className="dashboard-top-header">
          {showCreateButton && <Button onClick={() => setIsModalOpen(true)}>Create group</Button>}
          <div>
            <Input placeholder="Search Groups" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
          </div>
        </div>
        <div className="org-dashboard-page-body-grid">{renderGroups(groups, emptyMessage)}</div>
      </>
    );
  };

  // Create tabs data
  const tabsData = [
    {
      label: "Admin Groups",
      content: renderTabContent(adminGroups, "No Admin Groups Found", false)
    },
    {
      label: "User Groups",
      content: renderTabContent(userGroups, "No User Groups Found", true)
    }
  ];

  return (
    <div className="application_container">
      <AppLeftSideBar type="app" />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="dashboard_outer_section">
          {allGroupsOrApps.length > 0 && (
            <BuilderTabs tabs={tabsData} tabsClass="activity_tab" contentStyle={{ height: "calc(100% - 24px)" }} />
          )}
          <BuilderModal isOpen={isAssignOpen} onClose={() => setIsAssignOpen(false)} modalName="Assign Users">
            {isTableLoading ? (
              <div className="assign_loader_overlay">
                <Loader />
              </div>
            ) : (
              <UserAssignmentUI
                assignedUsers={selectedUsers}
                onAssign={assignUser}
                onRemove={removeUser}
                fetchSearchResults={fetchSearchResults}
              />
            )}
          </BuilderModal>
        </div>
      )}
      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName="Create Group">
        <CreateGroupModal handleSaveGroup={handleSaveGroup} />
      </BuilderModal>
    </div>
  );
};

const GroupAssignUser = ({ selectedUsers, removeUser, assignUser, isTableLoading }) => {
  // const [filteredData, setFilteredData] = useState(selectedUsers);
  const [nonAssignUsers, setNonAssignUsers] = useState(null);
  const [allUserObject, setAllUserObject] = useState(null);

  const fetchUsers = async () => {
    try {
      const { data: userData } = await axiosInstance.get(`/user-services/users?limit=20`);
      const newArray = mapArrayToObject(userData);
      setAllUserObject(newArray.result);
      afterEffect(newArray.result);
    } catch (error) {
      handleApiError(error);
    }
  };

  const afterEffect = async (userObj = allUserObject) => {
    const newArray = Object.values(userObj).filter((user) => {
      return !selectedUsers.some((u) => u.id === user.id);
    });
    setNonAssignUsers(newArray);
  };

  const debounce = (func, delay) => {
    let timeoutId;

    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const searchUsersByApi = debounce(async (searchTerm) => {
    try {
      const { data } = await axiosInstance.get(`user-services/users?search=${searchTerm}&limit=20`);
      const newArray = mapArrayToObject(data);
      setAllUserObject(newArray.result);
      afterEffect(newArray.result);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  }, 300);

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isTableLoading ? (
        <Loader />
      ) : (
        <div>
          <div className="user_org_container">
            <div className="user_org_heading d_flex align_center">
              <div className="user_select_dropdown_outer" style={{ marginLeft: "auto" }}>
                <SingleSelectBox
                  selectedData={""}
                  options={nonAssignUsers || []}
                  onChange={(obj) => assignUser(obj)}
                  placeholder="Select Users"
                  isSearch={true}
                  containerStyle={{ width: "80%", marginLeft: "auto" }}
                  apiCallback={(searchTerm) => {
                    searchUsersByApi(searchTerm);
                  }}
                  isApiSearch={true}
                />
              </div>
            </div>
          </div>

          {selectedUsers.length > 0 && (
            <>
              <div className="mt_3">
                <label className="builder_label mt_3">Users</label>
                <div className="selection_tag" style={{ marginTop: "0px" }}>
                  {selectedUsers.length > 0 ? (
                    selectedUsers.map((user) => (
                      <div className="org_chip" key={user.id}>
                        <div className="d_flex justify_between w_100">
                          <span className="font_size_medium font_weight_medium">{user.name}</span>
                          <div className="d_flex gap_2 align_center">
                            <ButtonActionIcon size="xsm" type="delete" onClick={() => removeUser(user.id)} />
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="no_data_text">No Users Found</div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {selectedUsers.length === 0 && <div className="no_data_text">No Users Found</div>}
    </>
  );
};

const GroupCard = ({ group, setSelectedApplication, deleteGroup, editGroup, setIsAssignOpen, allApplications }) => {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const chipStyleAdmin = {
    padding: "4px 8px",
    borderRadius: "9999px",
    fontSize: "12px",
    fontWeight: 500,
    color: "#d32f2f",
    backgroundColor: "#ffebee"
  };
  const chipStyleUser = {
    ...chipStyleAdmin,
    color: "#1976d2",
    backgroundColor: "#e3f2fd"
  };

  return (
    <div className="group_card">
      <div className="group_heading_outer w_100">
        <div className="d_flex justify_between align_center">
          <strong className="group_heading">{group.name}</strong>
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            {group.type === "admin" && (
              <span {...getToolTipAttributes(allApplications[group.app_id]?.name || "")} style={chipStyleAdmin}>
                Admin
              </span>
            )}
            {group.type === "user" && <span style={chipStyleUser}>User</span>}
          </div>
        </div>
        <div className="group_action_buttons">
          <ButtonActionIcon
            type="group_add"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedApplication(group.id);
              setIsAssignOpen(true);
            }}
          />
          {group.type !== "admin" && (
            <>
              <MaterialIcon name="edit" className="builder_action_btn edit" onClick={() => setIsEditOpen(true)} />
              <MaterialIcon
                name="delete"
                className="builder_action_btn delete"
                onClick={(e) => {
                  e.stopPropagation();
                  deleteGroup(group.id);
                }}
              />
            </>
          )}
        </div>
      </div>
      <span className="group_description">{group.description}</span>

      <BuilderModal isOpen={isEditOpen} onClose={() => setIsEditOpen(false)} modalName="Edit Group">
        <EditGroupInfo editGroup={editGroup} group={group} onClose={() => setIsEditOpen(false)} />
      </BuilderModal>
    </div>
  );
};

const EditGroupInfo = ({ editGroup, group, onClose }) => {
  const [isLoading, setIsLoading] = useState();
  const [inputValue, setInputValue] = useState({
    name: group.name,
    description: group.description
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await editGroup(group.id, inputValue);
    setIsLoading(false);
    onClose();
  };

  return (
    <div className="builder_form">
      <Input label="Group Name" type="text" value={inputValue.name} name="name" onChange={handleInputChange} />
      <Input
        label="Group Description"
        type="text"
        value={inputValue.description}
        name="description"
        onChange={handleInputChange}
      />
      <Button type="submit" onClick={handleSubmit} isLoading={isLoading}>
        Update
      </Button>
    </div>
  );
};

const CreateGroupModal = ({ handleSaveGroup }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [groupData, setGroupData] = useState({
    description: "",
    name: ""
  });

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setGroupData({ ...groupData, [name]: value });
  };

  const createUserGroup = async () => {
    setIsLoading(true);
    await handleSaveGroup(groupData);
    setIsLoading(false);
  };

  return (
    <div className="builder_form">
      <Input type="text" label="Enter Group Name" name="name" value={groupData.name} onChange={handleOnChange} />
      <Textarea
        label="Enter description"
        type="text"
        name="description"
        value={groupData.description}
        onChange={handleOnChange}
      />
      <Button onClick={createUserGroup} isLoading={isLoading}>
        Save
      </Button>
    </div>
  );
};

export default UserGroups;
export { GroupAssignUser };
